export const MIN_USERNAME_LENGTH = 5;
export const MAX_USERNAME_LENGTH = 35;

export const MIN_TITLE_LENGTH = 3;
export const MAX_TITLE_LENGTH = 40;

export const MIN_TEAM_NAME_LENGTH = 3;
export const MAX_TEAM_NAME_LENGTH = 40;

export const MIN_CHANNEL_NAME_LENGTH = 3;
export const MAX_CHANNEL_NAME_LENGTH = 40;

export const MIN_NUMBER_OF_CHAT_PARTICIPANTS = 0;

export const MIN_PASSWORD_LENGTH = 6;

export const ORGANIZATION_ID = 'b7838bf7-5f4b-4e40-b240-8f61e3e85edf';
export const API_KEY = '444a80545af3c6898c9b';
export const BASE_URL = 'https://api.cluster.dyte.in/v1';

export const CLOSED_MEETING_STATUS = 'CLOSED';
